import { ReactNode } from 'react';

/** Shared texture pattern for premium layouts */
const TEXTURE_PATTERN = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

export interface PremiumPageLayoutProps {
    /** Page content */
    children: ReactNode;
    /**
     * If true, uses h-screen flex-col layout for full-height editors.
     * `'lg'`: full height from the `lg` breakpoint only (independently scrolling columns);
     * below it the page scrolls normally.
     */
    fullHeight?: boolean | 'lg';
}

const LAYOUT_HEIGHT = { true: 'h-screen flex flex-col', lg: 'min-h-screen lg:h-screen lg:min-h-0 lg:flex lg:flex-col', false: 'min-h-screen' };
// `relative` : sans ancêtre positionné, un élément absolu (`sr-only` d'un panneau) se place par rapport
// à la page, échappe à l'overflow-hidden et allonge le document, qui se met à défiler en entier.
const CONTENT_HEIGHT = { true: 'relative flex-1 overflow-hidden', lg: 'relative lg:flex-1 lg:min-h-0 lg:overflow-hidden', false: '' };

export default function PremiumPageLayout({
    children,
    fullHeight = false,
}: PremiumPageLayoutProps) {
    return (
        <div className={`${LAYOUT_HEIGHT[`${fullHeight}`]} bg-gradient-to-br from-gray-50 via-gray-50/95 to-stone-50/90`}>
            {/* Subtle texture overlay */}
            <div
                className="fixed inset-0 pointer-events-none opacity-[0.015]"
                style={{ backgroundImage: TEXTURE_PATTERN }}
                aria-hidden="true"
            />
            {children}
        </div>
    );
}

export interface PremiumPageContentProps {
    children: ReactNode;
    className?: string;
    fullHeight?: boolean | 'lg';
}

/** Content wrapper for use after PremiumPageHeader */
export function PremiumPageContent({
    children,
    className = 'px-3 py-3 sm:px-6 sm:py-4',
    fullHeight = false,
}: PremiumPageContentProps) {
    return (
        <div className={`${className} ${CONTENT_HEIGHT[`${fullHeight}`]}`}>
            {children}
        </div>
    );
}
